import { render, staticRenderFns } from "./brand-activity-h5.vue?vue&type=template&id=a084bdf4&scoped=true&"
import script from "./brand-activity-h5.vue?vue&type=script&lang=js&"
export * from "./brand-activity-h5.vue?vue&type=script&lang=js&"
import style0 from "./brand-activity-h5.vue?vue&type=style&index=0&id=a084bdf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a084bdf4",
  null
  
)

export default component.exports